import { removeCountryCodeRegExp } from '@/utils/regexp.ts';

export default function isPhoneNumberEqualDespiteCountryCode(numberA: string, numberB: string) {
  return numberA.replace(removeCountryCodeRegExp, '0') === numberB.replace(removeCountryCodeRegExp, '0');
}
